import _Vue from 'vue'
import useElementUIPagination from '../mixins/useElementUIPagination'

const useElementUIPaginationMixinsPlugin = {
  install(Vue) {
    Vue.mixin(useElementUIPagination)
  },
}

_Vue.use(useElementUIPaginationMixinsPlugin)
